export default function DonatePayIcon({
  color,
  className,
}: {
  color?: string;
  className?: string;
}) {
  return (
    <>
      <svg
        width="27"
        height="27"
        viewBox="0 -8 31 31"
        fill={color || "#000000"}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path d="M21.063 5.802a.91.91 0 0 1 .916-.903.91.91 0 0 1 .916.903.91.91 0 0 1-.916.903.91.91 0 0 1-.916-.903ZM19.079 7.759a.91.91 0 0 1 .916-.904.91.91 0 0 1 .915.904.91.91 0 0 1-.915.903.91.91 0 0 1-.916-.903ZM23.963 6.855a.91.91 0 0 0-.916.904c0 .499.41.903.916.903a.91.91 0 0 0 .916-.903.91.91 0 0 0-.916-.904ZM21.063 9.716a.91.91 0 0 1 .916-.904.91.91 0 0 1 .916.904.91.91 0 0 1-.916.903.91.91 0 0 1-.916-.903Z"></path>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m15.704 11.208.003.003.002.004c1.426 2.03 3.237 3.619 6.194 3.619 3.913 0 7.097-3.14 7.097-7 0-3.855-3.19-7-7.097-7-2.175 0-3.859.918-5.1 2.189-1.215 1.243-2.068 2.788-2.909 4.313l-.084.153c-.86 1.557-1.729 3.077-2.758 4.138-.514.53-1.057.965-1.7 1.264-.645.301-1.375.46-2.255.46-3.1 0-5.592-2.459-5.592-5.517 0-3.043 2.507-5.516 5.592-5.516 2.504 0 3.992 1.398 5.237 3.266.263-.456.543-.92.84-1.39C11.764 2.293 9.96.835 7.097.835 3.184.834 0 3.974 0 7.834c0 3.854 3.19 7 7.097 7 2.155 0 3.838-.918 5.067-2.189.83-.857 1.488-1.862 2.093-2.908l.28-.485.257.497c.195.377.574 1.008.91 1.46Zm.647-1.69.003.004c1.31 2.135 2.844 3.828 5.549 3.828 3.085 0 5.593-2.473 5.593-5.516 0-3.059-2.492-5.516-5.593-5.516-1.807 0-2.97.646-4.02 1.722-.857.876-1.65 2.257-2.35 3.497l-.054.096.02.108c.047.236.207.579.366.889.166.323.354.655.484.883l.002.005Z"
          ></path>
          <path d="M6.41 5.35h1.222v1.807h1.831V8.36H7.632v1.806H6.41V8.361H4.579V7.157H6.41V5.35Z"></path>
        </g>
      </svg>
    </>
  );
}
